var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 47,
    rx: 11.5,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0961 16.5H30.9039C31.7857 16.5 32.5 17.2358 32.5 18.1442V19.2928C32.5 19.7335 32.3278 20.1567 32.022 20.4653L27.1432 25.4003C27.0591 25.4862 26.9448 25.5339 26.8266 25.5331L22.7417 25.5204C22.6174 25.5204 22.4992 25.4671 22.4143 25.374L17.9309 20.443C17.6537 20.1384 17.5 19.7359 17.5 19.3183V18.145C17.5 17.2366 18.2143 16.5 19.0961 16.5ZM22.9601 26.8681L26.601 26.8792C26.828 26.88 27.0118 27.0702 27.0118 27.3032V29.3515C27.0118 29.5854 26.879 29.7969 26.672 29.8948L23.367 31.4467C23.2898 31.4825 23.208 31.5 23.1261 31.5C23.0172 31.5 22.9083 31.4682 22.8134 31.4053C22.6473 31.2956 22.5469 31.1063 22.5469 30.9034V27.2921C22.5469 27.0574 22.7323 26.8673 22.9601 26.8681Z",
    fill: "#78828C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 47,
    rx: 11.5,
    stroke: "#ACADAD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.8686616102ed347f7249e55fc8c73fd5.svg";
export { ForwardRef as ReactComponent };